import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-10494470"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "work" }
const _hoisted_2 = { class: "worp" }
const _hoisted_3 = {
  class: "main",
  style: {"margin-right":"9px"}
}
const _hoisted_4 = { class: "mod_c_title" }
const _hoisted_5 = { class: "main_but bg_color_m" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "主持", -1))
const _hoisted_7 = { class: "guest" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item_text" }, "开播链接：", -1))
const _hoisted_9 = { class: "guest_item mar_bot" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item_text" }, "登陆密码：", -1))
const _hoisted_13 = { class: "guest_item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "修改", -1))
const _hoisted_15 = { class: "footer" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "打开链接", -1))
const _hoisted_17 = { class: "qrcode" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "foot_qr_box" }
const _hoisted_20 = {
  class: "main",
  style: {"margin-right":"9px"}
}
const _hoisted_21 = { class: "mod_c_title" }
const _hoisted_22 = { class: "main_but bg_color_g" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "嘉宾", -1))
const _hoisted_24 = { class: "guest" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item_text" }, "加入链接：", -1))
const _hoisted_26 = { class: "guest_item mar_bot" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1))
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item_text" }, "登陆密码：", -1))
const _hoisted_30 = { class: "guest_item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "修改", -1))
const _hoisted_32 = { class: "footer" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "打开链接", -1))
const _hoisted_34 = { class: "qrcode" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "foot_qr_box" }
const _hoisted_37 = { class: "main" }
const _hoisted_38 = { class: "mod_c_title" }
const _hoisted_39 = { class: "main_but bg_color_i" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "直播端", -1))
const _hoisted_41 = { class: "guest" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "item_text" }, "观看链接：", -1))
const _hoisted_43 = { class: "guest_item mar_bot" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1))
const _hoisted_45 = { key: 0 }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "guest_item" }, null, -1))
const _hoisted_47 = [
  _hoisted_46
]
const _hoisted_48 = { class: "footer" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "打开链接", -1))
const _hoisted_50 = ["data-clipboard-text"]
const _hoisted_51 = { class: "meeting" }
const _hoisted_52 = {
  key: 0,
  class: "meeting"
}

import { ref, computed, onUnmounted } from 'vue';
import ClipboardJS from 'clipboard';
import { message, Button, Tooltip, Popover, Radio } from 'ant-design-vue';
import http from '@/api';
import router from '@/router';
import { InteractionClass } from './liveMode';
import { useConsoleStore } from '@/pinia/console';
import { useQRCode } from '@vueuse/integrations/useQRCode';
import { useHomeStore } from '@/pinia/home';
import EventBus from '@/components/EventBus';
import { useDebounce } from '@/hooks/useDebounce'; //防抖
import { QuestionCircleFilled } from '@ant-design/icons-vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InteractLive',
  setup(__props) {

const homeStore = useHomeStore();
// const lowLatencyRole = computed(() => homeStore.funcData?.lowLatency);
const interactiveLianmai = computed(() => homeStore.funcData?.interactiveLianmai);

const consoleStore = useConsoleStore();
const rehearsal = computed(() =>
  consoleStore.consoleInfo.rehearsalSwitch ? `彩排密码：${consoleStore.consoleInfo.rehearsalPwd}` : ''
);
const aButton = Button;
const aTooltip = Tooltip;
const aPopover = Popover;
const aRadio = Radio;
const aRadioGroup = Radio.Group;
const studioId = router.currentRoute.value.params.studioId;
const liveStatus = ref<boolean>(false); //互动直播状态
const lowDelay = ref(false); //低延迟开关
const lowModal = ref(false); //开关提示框
const openModat = () => {
  lowModal.value = !lowModal.value;
};
// 获取状态
const getWebStatus = () => {
  const data = {
    studio_id: studioId,
  };
  http.liveMode.getInteractionStatus({ params: data }).then((res) => {
    liveStatus.value = res.data.data.status;
  });
};
// getWebStatus();
// 开启直播
const setInteractionStatus = () => {
  // 0关 1开
  const data = {
    studio_id: studioId,
    low_latency: lowDelay.value ? 1 : 0,
  };
  http.liveMode
    .setInteractionStatus(data)
    .then(() => {
      openModat();
      getWebStatus();
      getInteraction();
    })
    .catch((err) => message.error(err.data.error));
};
setInteractionStatus();
// 获取互动直播
const interactionState = ref<InteractionClass>({
  hostPasswordStatus: false,
  hostLink: '',
  hostPassword: ' ',
  helperPasswordStatus: false,
  helperLink: '',
  helperPassword: '',
  guestPasswordStatus: false,
  guestLink: '',
  guestPassword: '',
});
const password = ref();
const getInteraction = () => {
  const data = {
    studio_id: studioId,
  };
  http.liveMode.getInteraction({ params: data }).then((res) => {
    password.value = res.data.data.helper_password;
    interactionState.value = new InteractionClass(res.data.data);
  });
};
//  复制
const copyText = (btns: string) => {
  const ClipboardJSObj = new ClipboardJS(btns);
  ClipboardJSObj.on('success', (e) => {
    message.destroy();
    message.info('复制成功');
    e.clearSelection();
  });
  ClipboardJSObj.on('error', () => {
    message.destroy();
    message.info('复制失败');
  });
};
// 点击修改输入框
const state = ref({
  readonly1: true,
  readonly2: true,
  readonly3: true,
});
const setReadonly = (id: number) => {
  if (id === 1) {
    state.value.readonly1 = !state.value.readonly1;
    const getFocus = document.getElementById('readonly1');
    if (getFocus) {
      getFocus.focus();
    }
  } else if (id === 2) {
    // if (state.value.readonly2 === true) {
    state.value.readonly2 = !state.value.readonly2;
    const getFocus = document.getElementById('readonly2');
    if (getFocus) {
      getFocus.focus();
    }
    // }
  } else if (id === 3) {
    // if (state.value.readonly3 === true) {
    state.value.readonly3 = !state.value.readonly3;
    const getFocus = document.getElementById('readonly3');
    if (getFocus) {
      getFocus.focus();
    }
    // }
  }
};
// 修改密码
const setPassword = (keys: number) => {
  message.destroy();
  // 主持人
  if (keys === 1) {
    const data = {
      studio_id: studioId,
      password: interactionState.value.hostPassword,
    };
    http.liveMode
      .setHostPassword(data)
      .then((res) => {
        state.value.readonly1 = true;
        message.success(res.data.message);
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  } else if (keys === 2) {
    // 参会者
    const data = {
      studio_id: studioId,
      password: interactionState.value.helperPassword,
    };
    http.liveMode
      .setHelpPassword(data)
      .then((res) => {
        state.value.readonly2 = true;
        message.success(res.data.message);
      })
      .catch((err) => {
        state.value.readonly2 = true;
        interactionState.value.helperPassword = password.value;
        message.error(err.data.error);
      });
  } else if (keys === 3) {
    // 嘉宾
    const data = {
      studio_id: studioId,
      password: interactionState.value.guestPassword,
    };
    http.liveMode
      .setGuestPassword(data)
      .then((res) => {
        state.value.readonly3 = true;
        message.success(res.data.message);
      })
      .catch((err) => {
        message.error(err.data.error);
      });
  }
};

const hostLink = computed(() => interactionState.value.hostLink);
const qrcode1 = useQRCode(hostLink, {
  margin: 2,
});
const guestLink = computed(() => interactionState.value.guestLink);
const qrcode2 = useQRCode(guestLink, {
  margin: 2,
});

const meetMode = ref(0);
const getWastPattern = () => {
  http.liveMode.getWastPattern({ params: { studio_id: studioId } }).then((res) => {
    meetMode.value = res.data.data;
  });
};
getWastPattern();
const setWastPattern = () => {
  http.liveMode
    .setWastPattern({ studio_id: studioId, pattern: meetMode.value })
    .then((res) => message.success(res.data.message))
    .catch((err) => message.error(err.data.error));
};

const allowContinuou = ref(0);
const getVoiceSwitch = () => {
  http.liveMode.getVoiceSwitch({ params: { studio_id: studioId } }).then((res) => {
    allowContinuou.value = res.data.data.voice_interaction_switch;
  });
};
getVoiceSwitch();
const setVoiceSwitch = useDebounce(() => {
  http.liveMode
    .setVoiceSwitch({ studio_id: studioId, switch: allowContinuou.value })
    .then((res) => message.success(res.data.message))
    .catch((err) => message.error(err.data.error));
});

const getInteractionStatus = (data: any) => {
  console.log(data.voice_interaction_switch);
  allowContinuou.value = Number(data.voice_interaction_switch);
};
EventBus.on('interactionStatus', getInteractionStatus);

onUnmounted(() => {
  EventBus.off('interactionStatus', getInteractionStatus);
});

return (_ctx: any,_cache: any) => {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_svg_icon, { "icon-class": "but_main" })
          ]),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_a_input, {
              value: interactionState.value.hostLink,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((interactionState.value.hostLink) = $event)),
              class: "guest_in",
              readonly: ""
            }, null, 8, ["value"]),
            _createVNode(_unref(aTooltip), { placement: "top" }, {
              title: _withCtx(() => [
                _hoisted_10
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(aButton), {
                  class: "updata_but pledgeM",
                  "data-clipboard-text": 
                  '主持人链接：' + interactionState.value.hostLink + '\n' + '主持人密码：' + interactionState.value.hostPassword
                ,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (copyText('.pledgeM')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_icon, { "icon-class": "control_copy" })
                  ]),
                  _: 1
                }, 8, ["data-clipboard-text"])
              ]),
              _: 1
            })
          ]),
          (interactionState.value.hostPasswordStatus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_a_input, {
                    id: "readonly1",
                    value: interactionState.value.hostPassword,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((interactionState.value.hostPassword) = $event)),
                    class: _normalizeClass(["guest_in", { back: !state.value.readonly1 }]),
                    disabled: state.value.readonly1,
                    onBlur: _cache[3] || (_cache[3] = ($event: any) => (setPassword(1)))
                  }, null, 8, ["value", "class", "disabled"]),
                  _createVNode(_unref(aTooltip), { placement: "top" }, {
                    title: _withCtx(() => [
                      _hoisted_14
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(aButton), {
                        class: "updata_but",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (setReadonly(1)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_icon, { "icon-class": "but_updata" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_unref(aButton), {
            class: "open_box",
            href: interactionState.value.hostLink,
            target: "block"
          }, {
            default: _withCtx(() => [
              _hoisted_16,
              _createVNode(_component_svg_icon, { "icon-class": "but_computer" })
            ]),
            _: 1
          }, 8, ["href"]),
          _createVNode(_unref(aPopover), null, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("img", {
                  src: _unref(qrcode1),
                  alt: "QR Code"
                }, null, 8, _hoisted_18)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_svg_icon, { "icon-class": "control_qrcode" })
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_svg_icon, { "icon-class": "but_join" })
          ]),
          _hoisted_23
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_a_input, {
              value: interactionState.value.guestLink,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((interactionState.value.guestLink) = $event)),
              class: "guest_in",
              readonly: ""
            }, null, 8, ["value"]),
            _createVNode(_unref(aTooltip), { placement: "top" }, {
              title: _withCtx(() => [
                _hoisted_27
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(aButton), {
                  class: "updata_but pledgeC",
                  "data-clipboard-text": 
                  '嘉宾链接：' + interactionState.value.guestLink + '\n' + '嘉宾密码：' + interactionState.value.guestPassword
                ,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (copyText('.pledgeC')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_icon, { "icon-class": "control_copy" })
                  ]),
                  _: 1
                }, 8, ["data-clipboard-text"])
              ]),
              _: 1
            })
          ]),
          (interactionState.value.guestPasswordStatus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_a_input, {
                    id: "readonly3",
                    value: interactionState.value.guestPassword,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((interactionState.value.guestPassword) = $event)),
                    class: _normalizeClass(["guest_in", { back: !state.value.readonly3 }]),
                    disabled: state.value.readonly3,
                    onBlur: _cache[8] || (_cache[8] = ($event: any) => (setPassword(3)))
                  }, null, 8, ["value", "class", "disabled"]),
                  _createVNode(_unref(aTooltip), { placement: "top" }, {
                    title: _withCtx(() => [
                      _hoisted_31
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(aButton), {
                        class: "updata_but",
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (setReadonly(3)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_svg_icon, { "icon-class": "but_updata" })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createVNode(_unref(aButton), {
            class: "open_box",
            href: interactionState.value.guestLink,
            target: "block"
          }, {
            default: _withCtx(() => [
              _hoisted_33,
              _createVNode(_component_svg_icon, { "icon-class": "but_computer" })
            ]),
            _: 1
          }, 8, ["href"]),
          _createVNode(_unref(aPopover), null, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("img", {
                  src: _unref(qrcode2),
                  alt: "QR Code"
                }, null, 8, _hoisted_35)
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_36, [
                _createVNode(_component_svg_icon, { "icon-class": "control_qrcode" })
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("div", _hoisted_39, [
            _createVNode(_component_svg_icon, { "icon-class": "but_join" })
          ]),
          _hoisted_40
        ]),
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createVNode(_component_a_input, {
              value: interactionState.value.helperLink,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((interactionState.value.helperLink) = $event)),
              class: "guest_in",
              readonly: ""
            }, null, 8, ["value"]),
            _createVNode(_unref(aTooltip), { placement: "top" }, {
              title: _withCtx(() => [
                _hoisted_44
              ]),
              default: _withCtx(() => [
                _createVNode(_unref(aButton), {
                  class: "updata_but pledgeC",
                  "data-clipboard-text": '直播端链接：' + interactionState.value.helperLink,
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (copyText('.pledgeC')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_svg_icon, { "icon-class": "control_copy" })
                  ]),
                  _: 1
                }, 8, ["data-clipboard-text"])
              ]),
              _: 1
            })
          ]),
          (interactionState.value.helperPasswordStatus)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, _hoisted_47))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createVNode(_unref(aButton), {
            class: "open_box",
            style: {"width":"100%"},
            href: interactionState.value.helperLink,
            target: "block"
          }, {
            default: _withCtx(() => [
              _hoisted_49,
              _createVNode(_component_svg_icon, { "icon-class": "but_computer" })
            ]),
            _: 1
          }, 8, ["href"])
        ])
      ]),
      _createElementVNode("div", {
        class: "one_copy pledgeA",
        "data-clipboard-text": 
          '主持人链接：' +
          interactionState.value.hostLink +
          '\n' +
          '主持人密码：' +
          interactionState.value.hostPassword +
          '\n' +
          '嘉宾链接：' +
          interactionState.value.guestLink +
          '\n' +
          '嘉宾密码：' +
          interactionState.value.guestPassword +
          '\n' +
          '直播端链接：' +
          interactionState.value.helperLink +
          '\n' +
          _unref(rehearsal)
        ,
        onClick: _cache[12] || (_cache[12] = ($event: any) => (copyText('.pledgeA')))
      }, " 一键复制 ", 8, _hoisted_50)
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createTextVNode(" 会议模式： "),
      _createVNode(_unref(aRadioGroup), {
        name: "radioGroup",
        value: meetMode.value,
        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((meetMode).value = $event)),
        onChange: setWastPattern
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(aRadio), { value: 0 }, {
            default: _withCtx(() => [
              _createTextVNode("自动")
            ]),
            _: 1
          }),
          _createVNode(_unref(aRadio), { value: 1 }, {
            default: _withCtx(() => [
              _createTextVNode("音视频")
            ]),
            _: 1
          }),
          _createVNode(_unref(aRadio), { value: 2 }, {
            default: _withCtx(() => [
              _createTextVNode("纯音频")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"])
    ]),
    (_unref(interactiveLianmai))
      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
          _createTextVNode(" 允许观众连麦 "),
          _createVNode(_unref(aTooltip), null, {
            title: _withCtx(() => [
              _createTextVNode("匿名用户不能开启连麦功能。")
            ]),
            default: _withCtx(() => [
              _createVNode(_unref(QuestionCircleFilled))
            ]),
            _: 1
          }),
          _createTextVNode(" ： "),
          _createVNode(_unref(aRadioGroup), {
            name: "radioGroup",
            value: allowContinuou.value,
            "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((allowContinuou).value = $event)),
            onChange: _unref(setVoiceSwitch)
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(aRadio), { value: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("开")
                ]),
                _: 1
              }),
              _createVNode(_unref(aRadio), { value: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode("关")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "onChange"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})